import CloseIcon from 'src/images/CloseIcon'

interface BtnCloseProps {
  onClose: () => void
}

export const BtnClose = ({onClose}: BtnCloseProps) => {
  return (
    <button style={styles} onClick={onClose}>
      <CloseIcon width='12px' />
    </button>
  )
}
const styles: Record<string, string> = {
  position: 'absolute',
  right: '20px',
  top: '13px',
  minWidth: '0',
  background: 'none',
}
